export default "__VITE_ASSET__MIX729L1__"